import { axios } from '@Root/API'

export const remove = (entryProfileId, id) => {
	return axios.delete(`student-registration/${entryProfileId}/qualification-award/${id}`)
}
